import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

const Button = ({
  primary,
  secondary,
  tertiary,
  link,
  children,
  className,
  href,
  to,
  icon,
  active,
  submitting,
  compact,
  ...props
}) => {
  const baseClass = "button";
  let modifier;

  if (primary) {
    modifier = "primary";
  } else if (secondary) {
    modifier = "secondary";
  } else if (tertiary) {
    modifier = "tertiary";
  }

  const componentCls = link
    ? "link"
    : classnames(
        baseClass,
        {
          [`${baseClass}--${modifier}`]: modifier,
          [`${baseClass}--icon`]: icon,
          [`${baseClass}--active`]: active,
          [`${baseClass}--submitting`]: submitting,
          [`${baseClass}--compact`]: compact,
        },
        className
      );

  let Element;
  let additionalProps;

  if (href || to) {
    if (to || href.startsWith("/")) {
      Element = Link;
      additionalProps = {
        to: href || to,
      };
    } else {
      Element = "a";
      additionalProps = { href };
    }
  } else {
    Element = "button";
    additionalProps = {};
  }

  return (
    <Element {...props} {...additionalProps} className={componentCls}>
      <span>{children}</span>
      {submitting && <div className={`${baseClass}__loader`} />}
    </Element>
  );
};

Button.propTypes = {
  link: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  icon: PropTypes.bool,
  submitting: PropTypes.bool,
  active: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  compact: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./casper/sass/components/button/button.js